export default __webpack_public_path__ + "static/media/q8a.9c5e838b.png";